export enum SortOrder {
  SORT_ORDER_ASC = 'SORT_ORDER_ASC',
  SORT_ORDER_DESC = 'SORT_ORDER_DESC',
}
